export const iconFontAwesomeReligionOm = (
	<i className="fa-solid fa-om"></i>
);
